import React, { useContext, useState, useEffect, Fragment, memo } from "react";
import { Store } from "../../../state/state";
import SelectModel from "../../../common/SelectModel";
import { useObserver } from "mobx-react";
import { toJS } from "mobx";

const BlockCalender = ({ data, index }) => {
  const store = useContext(Store);
  const [day, setDay] = useState(1);
  const [month, setMonth] = useState(1);
  const [newColor, setNewColor] = useState(data.color);
  useEffect(() => {
    if (data.id) {
      let [notImportatn, monthN, dayN] = data.id.split("-");
      // console.log("day :", day);
      // console.log("month :", month);
      setDay(dayN - 1);
      setMonth(monthN - 1);
      // console.log(store.calenderRuslt[month - 1].date[day - 1]);
      // console.log(
      //   toJS(store.getBoxAttribute({ day: day - 1, month: month - 1 }, "color"))
      // );
      setNewColor(data.color);
    }
  }, [data]);
  const Block = useObserver(() => (
    <div
      id={data.state && "col-" + data.id}
      className={` ${
        data.state &&
        "box-border border transition-transform duration-500 block-system "
      } flex flex-col   bg-gray-${data.state !== null ? "100" : ""} ${
        "col-" + data.id === store.select ? " scale-block selectColor " : ""
      }`}
      style={{
        backgroundColor: data.color
          ? data.color
          : data.state
          ? store.theme.main.blockActive.backgroundColor
          : "transparent",
        transform:
          data.state !== null && data.id === store.select
            ? `scale(1.4);`
            : undefined,
        borderColor:
          "col-" + data.id === store.select
            ? "rgba(24, 123, 205, 0.8)"
            : store.theme.main.blockActive.borderColor,
        // height: "108px",
        maxHeight: "100%",
        // maxWidth: "120px",
        // boxSizing: "border-box",
        // margin: "0",
      }}
      onClick={() => {
        if (data.state) {
          store.setSelect(data.id);
        }
      }}
    >
      <div
        id={data.state ? "col-" + data.id : ""}
        className="flex-1 flex flex-col  text-center box-border"
        style={{
          height: "80%",
          width: "100%",
        }}
      >
        <span
          style={{
            fontSize: "10px",
            textAlign: "right",
            paddingRight: "5px",
          }}
          id={data.state ? "col-" + data.id : ""}
        >
          {data.col}
        </span>
        <div
          id={data.state ? "col-" + data.id : ""}
          className="flex-1 flex  justify-center items-center w-full box-border"
        >
          {data.content && (
            <Fragment>
              <span
                id={data.state && "col-" + data.id}
                className={" absolute text-5xl text-gray-800  z-0 " + data.icon}
                style={{ color: "rgba(0,0,0,0.1)" }}
              ></span>
              <span
                id={data.state && "col-" + data.id}
                className="text-center "
                style={{
                  fontSize: FontSize(data.content),
                  color: data.colorText,
                  fontFamily: data.fontFamily,
                }}
              >
                {data.content}
              </span>
            </Fragment>
          )}
        </div>
      </div>
      <div
        id={data.state && "col-" + data.id}
        className={`${
          data.state && store.theme.main.withBorderDays && "border-t border-l"
        }  h-4 w-4 flex justify-center items-center`}
        style={{ borderColor: store.theme.main.blockActive.borderColor }}
      >
        {data.current_today && store.theme.main.withBorderDays && (
          <div id={"col-" + data.id} className=" text-red-600 text-lg">
            X
          </div>
        )}
      </div>
    </div>
  ));
  return Block;
};
const FontSize = (font) => {
  if (font) {
    if (font.length > 30) {
      return "10px";
    } else if (font.length > 20) {
      return "10px";
    } else if (font.length > 10) {
      return "10px";
    }
  } else {
    return "";
  }
};
export default memo(BlockCalender);
